<template>
  <div v-if="product">
    <button
      v-if="!hasSizeAttribute && product.size_charts != ''"
      class="py-2 text-center bg-color-c8 text-black fontsize-small what-is-my-size mt-3"
      data-toggle="modal"
      data-target="#sizeModal"
    >
      جدول سایز
    </button>
    <div
      v-for="attribute in attributes"
      :key="attribute.id"
      class="product-details-size-choose mt- text-right d-flex align-items-center"
    >
      <div
        class="attribute-container text-right "
        :class="{
          box: attribute.style === 'box' || attribute.style === 'image',
          size: attribute.name == 'size',
        }"
      >
        <span >انتخاب {{ attribute.label }}</span>
        <div
          :class="{
            'attribute-values': !isSizeAndBoxedStyle(attribute),
            'attribute-values-size': isSizeAndBoxedStyle(attribute),
            'attribute-values-size-sizeButton':attribute.name == 'size'&&product != null && product.size_charts != '',
            big: getOptions(attribute).length > 4,
          }"
          class="mt-2"
        >
        <!-- 
          v-if="true"
        -->
        <treeselect
        v-if="attribute.style === 'select'"
            :clearable="false"
            @input="(e) => selectAttribute(e, attribute.id)"
            :searchable="!mediaQueries.mobileSize"
            :options="getOptions(attribute, attribute.style)"
            noChildrenText="فرزندی وجود ندارد"
            noOptionsText="موردی وجود ندارد"
            noResultsText="موردی یافت نشد"
            :placeholder="attribute.label"
          />
          <BoxSelect
            v-else-if="attribute.style === 'box'"
            :options="getOptions(attribute, attribute.style)"
            @input="(e) => selectAttribute(e, attribute.id)"
            :value="getAttributeSelectedValue(attribute.id)"
          />
          <BoxImage
            v-else-if="attribute.style === 'image'"
            :options="getOptions(attribute, attribute.style)"
            @input="(e) => selectAttribute(e, attribute.id)"
            :value="getAttributeSelectedValue(attribute.id)"
          />
          <template v-if="attribute.name == 'size'">
            <button
              v-if="product != null && product.size_charts != ''"
              class="py-2 text-center  bg-transparent text-pink-theme2  font-bold fontsize-small  what-is-my-size" style="border:1px solid #ff7892"
              :class="{ 'px-2': attribute.style !== 'select' }"
              data-toggle="modal"
              data-target="#sizeModal"
            >
              سایز من چنده؟
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div v-else style="width: 145px;" class="d-inline-block ml-2">
    <b-skeleton type="button" width="100%" />
  </div>
</template>

<script>
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BoxSelect from "@/parts/Front/components/productDetail/attributes/BoxSelect";
import BoxImage from "./attributes/BoxImage";
import { BSkeleton } from "bootstrap-vue";

export default {
  name: "ProductAttributes",

  inject: ["mediaQueries"],
  components: { BoxImage, BoxSelect, Treeselect, BSkeleton },
  props: {
    value: Object,
  },
  data() {
    return {
      product: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.product = newVal;
    },
    product(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    attributes() {
      return this.product.getAttributes();
    },
    hasSizeAttribute() {
      return this.attributes.find((attr) => attr.name == "size");
    },
  },
  methods: {
    isSizeAndBoxedStyle(attribute) {
      return attribute.name == "size" && attribute.style === "box";
    },
    getAttributeSelectedValue(attrId) {
      let val = this.product.selected_attributes_id.find(
        (item) => item.id == attrId
      );
      return val ? val.value : null;
    },
    getOptions(attribute, style) {
      let options = [];
      attribute.values.forEach((attr) => {
        options.push({
          id: attr.value,
          label: attr.value,
          isDisabled: !this.product.isAttributeAvailable(attr),
          selectableAnyways: attribute.name == "tarh",
          variety:
            attribute.name == "tarh"
              ? this.product.findVarietyForAttributeValue(attr.id, attr.value)
              : null,
        });
      });
      if (style == "select") {
      }
      options = options.sort((a, b) => a.isDisabled - b.isDisabled);
      return options;
    },
    selectAttribute(selectedValueValue, attributeId) {
      let selectedValue = null;
      this.attributes.forEach((attr) => {
        if (selectedValue) {
          return;
        }
        if (attr.id == attributeId) {
          attr.values.forEach((val) => {
            if (val.value == selectedValueValue) {
              selectedValue = val;
            }
          });
        }
      });
      if (!selectedValue) {
        this.product.deselectAttribute(attributeId);
      } else {
        this.product.selectAttribute(
          selectedValue.id,
          selectedValue.value,
          selectedValue.valueId
        );
      }
    },
  },
};
</script>

<style scoped>

.attribute-container {
  max-width: 200px;
}

.attribute-container.size {
  max-width: 198px;
}

.attribute-container.box {
  max-width: unset;
}

.what-is-my-size {
  min-width: 90px;
  margin-right: 9px;
  height: 36px;
  padding: 0 !important;
  font-size: 14px !important;
}

.attribute-values {
  display: flex;
  justify-content: center;
}

.attribute-values-size {
  display: flex;
  justify-content: center;
  align-items: center;
}
.attribute-values-size .vue-treeselect {
  width: 131px;
  height: 40px;
}

@media screen and (max-width: 768px) {
  .attribute-values-size.big >>> .box-select-option,
  .attribute-values-size.big >>> .what-is-my-size {
    margin-bottom: 7px;
  }
}
.attribute-values-size.attribute-values-size-sizeButton.big {
    min-width: 300px;
    justify-content: space-between;
}
@media screen and (max-width: 400px) {
  .product-details-size-choose.text-right {
    margin: 0 -10px 0 -10px;
  }
}
</style>
<style>
.attribute-values .vue-treeselect {
  width: 300px !important;
}
.vue-treeselect__list-item {
    border-bottom: 1px solid #1213;
    padding: 4px;
}


</style>
